import { Box, Typography, List, ListItem, ListItemText, Link } from "@mui/material";
import { Modal } from "components/Modal";
import { FC, useState, useMemo } from "react";
import { CustomLabel } from "types/CustomLabel";
import { Requirement } from "types/requirement";
import { SuccessRubric } from "./SuccessRubric";

type ITERSuccessRubricProps = {
  open: boolean;
  onClose: () => void;
  requirement: Requirement;
  customLabels?: CustomLabel[];
};

export const ITERSuccessRubric: FC<ITERSuccessRubricProps> = ({
  open,
  onClose,
  requirement,
  customLabels = [],
}) => {
  const [selectedSubRequirement, setSelectedSubRequirement] = useState<Requirement | null>(null);
  const [openSubRubric, setOpenSubRubric] = useState(false);

  const subRequirements = useMemo(() => {
    if (!requirement?.competencies) {
      return [];
    }
    return requirement.competencies
      .map((c: any) => c.competency)
      .filter(Boolean);
  }, [requirement]);

  const handleOpenSubRubric = (subReq: Requirement) => {
    setSelectedSubRequirement(subReq);
    setOpenSubRubric(true);
  };

  const handleCloseSubRubric = () => {
    setOpenSubRubric(false);
    setSelectedSubRequirement(null);
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        title={`Rubric of Success for ${requirement.name}`}
        size="medium"
      >
        <Box>
          <Typography variant="h6" gutterBottom>
            Competencies
          </Typography>
          <List>
            {subRequirements.map((subReq: Requirement) => (
              <ListItem
                key={subReq.requirement_id}
                sx={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                <ListItemText
                  primary={subReq.name}
                  secondary={subReq.description}
                />
                {subReq.evaluation_metrics &&
                  subReq.evaluation_metrics.length > 0 && (
                    <Box mt={1} width="100%">
                      <Link
                        onClick={() => handleOpenSubRubric(subReq)}
                        sx={{ cursor: "pointer" }}
                      >
                        See Success Rubric
                      </Link>
                    </Box>
                  )}
              </ListItem>
            ))}
          </List>
        </Box>
      </Modal>
      {openSubRubric && selectedSubRequirement && (
        <SuccessRubric
          open={openSubRubric}
          onClose={handleCloseSubRubric}
          requirement={selectedSubRequirement}
          customLabels={customLabels}
        />
      )}
    </>
  );
};

